import React from "react";
import "../../index.scss";
import "./Responsive.scss";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";


const PetarLubardaText = () => {
  return (
    <Container
      sm={{ span: 12 }}
      md={{ span: 12 }}
      lg={{ span: 12 }}
      xl={{ span: 12 }}
      className="container-artist-data"
      style={{ maxWidth: '100%' }}
    >
      <Row>
        <Col
          sm={{ span: 12 }}
          md={{ span: 11, offset: 1 }}
          lg={{ span: 11, offset: 0 }}
          xl={{ span: 11, offset: 0 }}
        >
          <div className="artist-info-text" style={{ width: "100%" }}>
            <p style={{ color: "dimgray" }}>
              <font color="black">
                <b>PETAR LUBARDA </b>
              </font>
              je rođen 1907. u Ljubotinju nedaleko od Cetinja, od oca Đura I.
              Lubarde, oficira crnogorske vojske, a potom potpukovnika Vojske
              Kraljevine Jugoslavije, i majke Marije M. Vujović, domaćice. Imao
              je petoro braće i sestara. <br />
              <br />
              <font color="#414141">
                <b>Školovanje 1914–1926</b>
              </font>
              <br />
              Osnovnu školu započinje u Ljubotinju a nastavlja na Cetinju i u
              Herceg Novom. Zbog očevih oficirskih obaveza, često se sa
              porodicom preseljava. Gimnazijsko školovanje započinje u Herceg
              Novom i nastavlja u Splitu, Sinju i Nikšiću, gde stiče prva
              saznanja o slikarstvu kao profesiji. U Nikšiću, kao đak završnog
              razreda gimnazije, 1925. priređuje prvu samostalnu izložbu. Iste
              godine se upisuje na <i>Umetničku školu</i> u Beogradu, gde su mu
              profesori bili Ilija Šobajić, Ljuba Ivanović i Beta Vukanović.
              Međutim, nakon nekoliko meseci prekida školovanje i 1926. odlazi u
              Pariz. <br />
              <br />
              <font color="#414141">
                <b>Pariz 1926–1932</b>
              </font>
              <br />U Parizu se upisuje na <i>Académie des Beaux Arts</i>, ali
              zbog loše finansijske situacije i nezadovoljstva, odustaje.
              Obilazi muzeje i galerije, radi samostalno u jeftinim otvorenim
              ateljeima. Na njega više utiču klasični majstori (Rembrant,
              Ticijan, El Greko) nego savremena strujanja. Izlaže na{" "}
              <i>Salonu nezavisnih (Salon des Indépendants)</i> 1927. Sa grupom
              srpskih umetnika koji žive u Parizu izlaže 1928. u Slavističkom
              institutu u Parizu. Prvi put samostalno izlaže u Rimu 1929. u{" "}
              <i>Casa dell’ Arte Bragaglia</i>. Prvi susret sa srednjovekovnim
              fresko-slikarstvom doživeo je u Parizu kada je u izlogu jedne
              knjižare video otvorenu knjigu sa reprodukcijom „Pokolja
              Vitlejemske dece” iz Markovog manastira u okolini Skoplja.
              <br />
              <br />
              <font color="#414141">
                <b>Slike:</b>
              </font>
              <br />
              <b>Pejzaž s fenjerom</b> (1927), <b>Crveni pejzaž</b> (1927),{" "}
              <b>Za stolom</b> (1927), <b>Ciganka [Crnogorka]</b> (1928),{" "}
              <b>Naga žena</b> (1928), <b>Motiv sa Marne </b> (1931)
              <br />
              <br />
              <font color="#414141">
                <b>Povratak 1932–1938</b>
              </font>
              <br />
              Vraća se u Jugoslaviju 1932. gde živi u Beogradu, ali često boravi
              u Crnoj Gori i u Dalmaciji. Već od sledeće godine redovno izlaže
              na „Prolećnim izložbama slikarskih i vajarskih radova
              jugoslovenskih umetnika”, a od 1935. i na „Jesenjim izložbama
              slikarskih i vajarskih radova beogradskih umetnika” u{" "}
              <i>Umetničkom paviljonu „Cvijeta Zuzorić”</i>. Prvu samostalnu
              izložbu priredio je 1933. godine u Beogradu u{" "}
              <i>Francusko-srpskom klubu</i>. Samostalno izlaže 1934. i 1937. u{" "}
              <i>Umetničkom paviljonu</i>. Ovu drugu izložbu otvorio je Milan
              Kašanin, upravnik <i>Muzeja kneza Pavla</i>. Izlaže u{" "}
              <i>Jugoslovenskom paviljonu</i> na Svetskoj izložbi u Parizu 1937.
              i dobija <i>Grand Prix</i>. Postaje član Društva srpskih umetnika
              „Lada” 1938. sa kojim od tada redovno izlaže.
              <br />
              <br />
              <font color="#414141">
                <b>Slike: </b>
              </font>
              <br />
              <b>Portret crnogorca</b> (1933), <b>Majka sa detetom</b> (1934),{" "}
              <b>Prodavac pomorandži</b> (1936), <b>Glava seljaka</b> (1937),{" "}
              <b>Nosač</b> (1937), <b>Šiptar</b> (1936),{" "}
              <b>Pogreb [Motiv iz Crne Gore] </b> (1933),{" "}
              <b>Motiv iz Crnogorskog primorja</b> (1933), <b>Dubrovnik</b>{" "}
              (1935), <b>Predeo iz Rume</b> (1937), <b>Gruda</b> (1933),{" "}
              <b>Stari Bar</b> (1936), <b>Rijeka Crnojevića</b> (1937),{" "}
              <b>Bombardovanje San Sebastijana</b> (1937), <b>More</b> (1938),{" "}
              <b>Pejzaž s crkvom</b> (1938), <b>Virpazar</b> (1937)
              <br />
              <br />
              <font color="#414141">
                <b>Pariz 1938–1940</b>
              </font>
              <br />
              Odlazi u Pariz gde ostaje do 1940. Putuje po Španiji, Nemačkoj,
              Tunisu, Alžiru i Egiptu. Muzej <i>Jeu de Paume</i> u Parizu
              otkupljuje sliku <b>Žabljak na Skadarskom jezeru</b> 1938. Slika
              se danas nalazi u <i>Fonds national d’art contemporain</i>, pri
              Centru „Žorž Pompidu” u Parizu. Sledeće godine dobija prvu nagradu
              na internacionalnoj izložbi slikarstva u Hagu.
              <br />
              <br />
              <font color="#414141">
                <b>Slike: </b>
              </font>
              <br />
              <b>Maslina</b> (1938), <b>Enterijer</b> (1938), <b>Vaza</b>{" "}
              (1939), <b>Primorje – Zaliv</b> (1940), <b>Isentemba</b> (1939),{" "}
              <b>Zaklano jagnje</b> (1940), <b>Fazan</b> (1940),{" "}
              <b>Mrtva priroda sa belom činijom</b> (1940),{" "}
              <b>Mrtva priroda sa armaturom</b> (1941)
              <br />
              <br />
              <font color="#414141">
                <b>Zarobljeništvo 1941–1944</b>
              </font>
              <br />
              Rat provodi kao ratni zarobljenik u logorima u Nemačkoj i Italiji.
              Sve vreme crta i slika.
              <br />
              <br />
              <font color="#414141">
                <b>Crteži:</b>
              </font>
              <br />
              <b>Zarobljenik</b> (1941), <b>Glava</b> (1941), <b>Šinjel</b>{" "}
              (1943), <b>Iz logora – skica</b> (1943),{" "}
              <b>Čitanje pisma u logoru</b> (1943),{" "}
              <b>Zarobljenik iz nemačkog logora</b> (1943),{" "}
              <b>Logor u Italiji</b> (1943)
              <br />
              <br />
              <font color="#414141">
                <b>Slike: </b>
              </font>
              <br />
              <b>Glava zarobljenika</b> (1942), <b>Zarobljenik čita novine</b>{" "}
              (1942), <b>Stalag – Drugovi</b> (1942), <b>Logor</b> (1942),{" "}
              <b>Kroz prozor</b> (1942), <b>Motiv iz logora</b> (1942),{" "}
              <b>Predvečerje u logoru</b> (1943), <b>Kutak zida</b> (1943),{" "}
              <b>Iz logorske barake</b> (1943), <b>U baraci</b> (1943)
              <br />
              <br />
              <font color="#414141">
                <b>Posleratne godine 1945–1949</b>
              </font>
              <br />
              Živi u Beogradu. Oca Đuru streljaju nove komunističke vlasti. Ženi
              se Verom Protić, studentkinjom <i>Likovne akademije</i> u
              Beogradu. Učestvuje na izložbama{" "}
              <i>Udruženja likovnih umetnika Srbije</i>. Radi kao profesor na{" "}
              <i>Likovnoj akademiji</i> do 1946. kada ga, kao navodnog
              predstavnika „formalističke škole”, zajedno sa Milom Milunovićem
              premeštaju na službu na Cetinje. Učestvuje u formiranju i na prvoj
              izložbi <i>Udruženja likovnih umetnika Crne Gore</i>. Postaje
              drugi predsednik ULUCG-a. Učestvuje u formiranju{" "}
              <i>Umetničke škole</i> na Cetinju 1947. Bio je njen profesor i
              prvi direktor. Boravkom na Cetinju, u ponovnom susretu sa
              prirodom, Lubarda pravi istorijski zaokret ka uspostavljanju jedne
              sasvim originalne modernističke koncepcije slike. Ovde nastaju
              neka njegova kapitalna dela, koja će kasnije biti izložena na
              istorijskoj izložbi u Umetničkoj galeriji ULUS-a. Tokom 1948.
              obilazi manastire u Makedoniji i Srbiji.
              <br />
              <br />
              <font color="#414141">
                <b>Slike:</b>
              </font>
              <br />
              <b>Patnje naroda</b> (1944–1945), <b>Juriš</b> (1945),{" "}
              <b>Žetva – vršidba</b> (1946), <b>Sećanje na 1941. godinu</b>{" "}
              (1947), <b>Vagonet</b> (1948), <b>Motiv iz Crmnica</b> (1946),{" "}
              <b>Donji kraj</b> (1947), <b>Predeo sa plavim brdima, Narovi</b>{" "}
              (1949), <b>Cetinje sa Lovćenom</b> (1949)
              <br />
              <br />
              <font color="#414141">
                <b> Istorijska izložba 1950-1951</b>
              </font>
              <br />
              Učestvuje na <i>Venecijanskom bijenalu</i> 1950. u jugoslovenskom
              paviljonu sa G. A. Kosom, B. Ilićem, I. Mujezinovićem, A.
              Augustinčićem, F. Kršinićem, V. Radaušem, V. Bakićem, K. Angeli
              Radovanijem i Z. Mušičem. Komesar je bio Petar Šegedin. Izlaže na
              prvoj izložbi grupe „Samostalni”.U{" "}
              <i>Umetničkoj galeriji ULUS-a</i> 1. maja 1951. otvorio je
              samostalnu izložbu na kojoj su izložena 52 rada. Izložba je
              predstavljala prekretnicu na tadašnjoj umetničkoj sceni. Predgovor
              u katalogu pišu Predrag Milosavljević i Miodrag B. Protić.
              <br />
              <br />
              <b>Izlaže slike: </b>
              <br />
              <b>Selo Brajići</b> (1949), <b>Primorska kuća, Crnogorsko selo</b>{" "}
              (1949), <b>Brda nad Kotorom, Crna Gora</b> (1951),{" "}
              <b>Kvrgava stena</b> (1951), <b>Zubata stena</b> (1951),{" "}
              <b>Kamena pučina</b> (1951), <b>Suvo drvo</b> (1950),{" "}
              <b>Skica za kompoziciju „Bitka na Vučijem Dolu”, Durmitor</b>{" "}
              (1950)
              <br />
              <br />
              <font color="#414141">
                <b> Međunarodna afirmacija 1952-1960</b>
              </font>
              <br />
              Otvara izložbu u Jugoslovenskom centru u Parizu 1952. Predgovor za
              katalog napisao Žan Kasu. Dobija pozitivne kritike u Francuskoj.
              Završava zidnu sliku <b>Kosovski boj</b> za svečanu dvoranu{" "}
              <i>Izvršnog veća Narodne Republike Srbije</i>. Izlaže na Bijenalu
              u Sao Paolu 1954. gde biva izuzetno zapažen i dobija jednu od tri
              otkupne nagrade za slikarstvo. Iste godine izlaže u{" "}
              <i>Galeriji Michel Warren</i> u Parizu. Na Trećem bijenalu
              likovnih umetnosti u Tokiju 1955. dobija jednu od četiri
              ravnopravne nagrade. Izlaže u Londonu u <i>Galeriji Leichester</i>
              . Dobija nacionalnu nagradu Gugenhajmove zadužbine 1956. u visini
              od 1000 dolara za sliku <b>Borba konja</b>. Lubardinom samostalnom
              izložbom 1958. otvara se novosagrađeni{" "}
              <i>Umetnički paviljon u Titogradu</i>. U okviru Svetske izložbe
              EXPO u Briselu, u <i>Palais International des Beaux-Arts</i> na
              izložbi pod nazivom „50 godina moderne umetnosti” uvršćena je i
              Lubardina slika <b>Mediteran</b> iz 1952. Jedini je jugoslovenski
              slikar čije je delo reprodukovano u „Istoriji modernog slikarstva”
              Herberta Rida. U selekciji Zorana Kržišnika, sa D. Džamonjom
              ponovo izlaže u Jugoslovenskom paviljonu na{" "}
              <i>Venecijanskom bijenalu 1960.</i>
              <br />
              <br />
              <font color="#414141">
                <b>Slike: </b>
              </font>
              <br />
              <b>Fantastični predeo</b> (1951), <b>Guslar</b> (1952),{" "}
              <b>Fosil</b> (1952), <b>Simfonija Orjenta</b> (1953), <b>Konji</b>{" "}
              (1953), <b>Stena</b> (1954), <b>Između dana i noći</b> (1955),{" "}
              <b>Sutjeska</b> (1956), <b>Kosmač</b> (1957),{" "}
              <b>Jutro [Pogled s Lovćena] </b> (1958), <b>Ostrva</b> (1959),{" "}
              <b>Svečanost</b> (1959), <b>Industrijalizacija</b> (1959),{" "}
              <b>Zvuk</b> (1960)
              <br />
              <font color="#414141">
                <b> Državni umetnik 1961-1968.</b>
              </font>
              <br />
              Izabran za redovnog člana SANU. Samostalna izložba 36 radova u{" "}
              <i>Galeriji kulturnog centra Beograda</i> zamišljena je kao
              „reprezentativni” kulturni događaj uz Prvu konferenciju Pokreta
              nesvrstanih zemalja 1961. Izveo <b>Put u kosmos</b>, „najveću
              jugoslovensku sliku”, površine oko 100 m2, za svečanu salu zgrade{" "}
              <i>Saveznog izvršnog veća</i>. Izlaže u <i>Galeriji Penelope</i> u
              Rimu, a tekst u katalogu potpisuje Đulio Karlo Argan. Odlazi u
              Indiju 1963. kao gost indijske Komisije za kulturne veze sa
              inostranstvom. Izlaže u Nju Delhiju i Bombaju, a biva primljen i
              kod premijera Nehrua kome poklanja sliku. Zastupljen je u knjizi
              „Savremeni slikari” francuske izdavačke kuće Lucien Maseno za koju
              je uvod napisao Bernar Dorival. Radi zidnu sliku{" "}
              <b>Velika štafeta ljudskog razuma</b> u zgradi SIV-a. Kao njen
              prvi dobitnik, 1966. dobija nagradu AVNOJ-a.{" "}
              <i>Muzej savremene umetnosti</i> priređuje 1967. retrospektivnu
              izložbu sa oko 100 radova povodom četrdeset godina rada i šezdeset
              godina života. Naredne godine, na izložbama u{" "}
              <i>Umetničkom paviljonu</i> u Titogradu i u <i>Plavom dvorcu</i>{" "}
              na Cetinju, predstavlja 37 novih radova. U <i>Narodnom muzeju</i>{" "}
              u Kragujevcu izlaže 27 slika posvećenih masakru 21. oktobra 1941.
              Slike poklanja galeriji budućeg Spomen-muzeja.
              <br />
              <br />
              <font color="#414141">
                <b>Slike: </b>
              </font>
              <br />
              <b>Plamena ptica</b> (1962), <b>Sunce</b> (1963),{" "}
              <b>Magično ogledalo</b> (1964), <b>Iz hiljadu i jedne noći</b>{" "}
              (1964), <b>Sa Indijskog okeana</b> (1964),<b>Sunce</b> (1965),{" "}
              <b>Bik</b> (1966), <b>13. julski ustanak</b> (1967),{" "}
              <b>Prometej</b> (1967), <b>Bizon</b> (1967), <b>Vatreni zid</b>{" "}
              (1967), <b>Crveni oblaci</b> (1968)
              <br />
              <br />
              <font color="#414141">
                <b> Poslednje godine 1969-1973.</b>
              </font>
              <br />
              Godine 1969. u <i>Galeriji SANU</i> priređuje izložbu sa radovima
              od 1927. do 1969. Za sliku <b>Sumrak Lovćena</b> dobija nagradu
              Oktobarskog salona 1970. Odbija da uđe u Odbor za podizanje
              Njegoševog mauzoleja na Lovćenu. Odbija da izlaže na
              reprezentativnoj izložbi posleratne umetnosti Crne Gore u{" "}
              <i>Muzeju savremene umetnosti</i> u Beogradu „jer se ne smatra
              Crnogorcem”. Tri dana pre otvaranja izložbe „Apstraktno slikarstvo
              u Srbiji 1951–1971” autora Lazara Trifunovića, u{" "}
              <i>Likovnoj galeriji Kulturnog centra Beograda</i>, povlači radove
              sa obrazloženjem da se ne slaže sa naslovom izložbe. Poklanja dve
              slike kao prilog velikoj društvenoj akciji izgradnje železničke
              pruge Beograd–Bar. Dobija nagradu Herderove fondacije za 1972.
              godinu. Za Narodnu biblioteku Srbije 1973. izvodi svoju poslednju
              sliku –{" "}
              <b>
                <i>Prvi srpski ustanak.</i>
              </b>
              <br />
              <br />
              <font color="#414141">
                <b>Slike: </b>
              </font>
              <br />
              <b>Hod vremena</b> (1969), <b> „Protubarnea” Izvor svetlosti</b>{" "}
              (1969), <b>Pejzaž</b> (1970), <b>Sunce</b> (1972)
              <br />
              <br />
              <font color="#414141">
                <b>1974.</b>
              </font>
              <br />
              Trinaestog februara 1974. Lubarda umire u Železničkoj bolnici u
              Beogradu. Sahranjen je u <i>Aleji velikana</i> na Novom groblju u
              Beogradu. <i>Narodni muzej</i> u Beogradu i{" "}
              <i>Muzej savremene umetnosti</i> u Skoplju organizuju
              komemorativne izložbe radova Petra Lubarde iz svojih zbirki.
              Skupština Grada Beograda potpisuje ugovor sa umetnikovom udovicom
              Verom Lubardom o poklonu gradu dela kolekcije (57 slika, 72 crteža
              i skice, 61 tempera na hartiji, jedna mapa sa 60 skica, kao i
              originalan nameštaj i pribor koji su se nalazili u Lubardinom
              ateljeu) i otvaranju spomen-galerije „Atelje Petra Lubarde”. Vrlo
              brzo nakon otvaranja, atelje je zatvoren zbog nedefinisanih odnosa
              sa Verom Lubardom. <br />
              <br />
            </p>
          </div>
          <br />
        </Col>
      </Row>
    </Container>
  );
};

export default PetarLubardaText;
